import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ee4a1b66&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee4a1b66')) {
      api.createRecord('ee4a1b66', component.options)
    } else {
      api.reload('ee4a1b66', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ee4a1b66&", function () {
      api.rerender('ee4a1b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/informine/information/index.vue"
export default component.exports